<template>
    <div class="JobStatusProgressBar text-white relative text-center">
        <div class="container py-8">
            <!-- Headline and progress bar  -->
            <div class="max-w-5xl mx-auto">
                <div class="range-block">
                    <RangeSlider :class="progressBarColor" :value="progressBarWidth" :disabled="true" />

                    <div class="range-table" v-if="!hasFailed">
                        <table v-if="status !== 'content_denied'" class="table-fixed w-full mt-5 text-sm">
                            <tr>
                                <td
                                    v-for="step of ['applied', 'todo'/* content_denied */, 'inprogress', 'finished']"
                                    :key="steps[step].label"
                                    v-text="steps[step].label"
                                />
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.JobStatusProgressBar__controls {
    @apply sticky -mb-8 top-0 inset-x-0 z-10 text-right p-3;
}

body.--agent-web .JobStatusProgressBar__controls {
    @apply top-16;
}

@screen sm {
    .JobStatusProgressBar__controls {
        @apply static -mb-12;
    }
}

.JobStatusProgressBar {
    .range-slider-fill,
    .range-slider-knob {
        transition: all 0.6s ease;
    }
}

.JobStatusProgressBar .JobStatusProgressBar__btn {
    @apply w-full mb-4;
}

@screen sm {
    .JobStatusProgressBar .JobStatusProgressBar__btn {
        @apply w-auto mb-auto mx-2;
    }
}
@media (max-width: 768px){
    .range-block {
        position: relative;
        padding-top: 100%;
        max-height: 400px;
        .range-slider {
            position: absolute;
            top: 0;
            left: 15px;
            right: 0;
            transform: rotate(90deg);
            transform-origin: left top;
        }
        .range-table {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 20px;
            .table-fixed {
                height: 100%;
                position: relative;
                margin-top: 0;
                tr {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    text-align: left;
                    align-items: stretch;
                    height: 100%;
                }
            }
        }
    }
}
</style>

<script type="text/babel">
import { ReplaySubject } from 'rxjs'
import ChatModal from 'dashboard-js/components/chat/ChatModal'
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import RangeSlider from 'dashboard-js/components/utilities/RangeSlider'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'
import ReviewCard from 'dashboard-js/components/reviews/ReviewCard'
import orderBy from 'lodash-es/orderBy'

export default {
    components: { ChatModal, ReviewCard, RangeSlider },

    mixins: [HasLoadingState, HasSubscriptions, RestoreOnPageBack],

    props: ['chatThreadId', 'dataJob', 'steps', 'showOnlySteps'],

    data() {
        return {
            job: this.dataJob,
            initializing: true,
        }
    },

    computed: {
        contents() {
            return orderBy(this.$get(this.job, 'contents', []), 'media_published_at')
        },

        currentStep() {
            return this.steps[this.status]
        },

        hasFailed() {
            return ['cancelled', 'declined'].indexOf(this.status) !== -1
        },

        hasSucceeded() {
            return ['finished'].indexOf(this.status) !== -1
        },

        progressBarColor() {
            if (this.hasFailed) {
                return '--danger'
            }
            if (this.hasSucceeded) {
                return '--success'
            }
            return ''
        },

        progressBarWidth() {
            if (this.initializing) {
                return 0
            }

            let stepSize = ['applied', 'todo', 'inprogress', 'finished'].indexOf(this.status) + 1

            if (['cancelled', 'declined'].indexOf(this.status) !== -1) {
                stepSize = 4
            }

            // if (this.status === 'content_denied') {
            //     stepSize = 2
            // }

            return stepSize === 4 ? 100 : stepSize * 25
        },

        slotScope() {
            return {
                job: this.job,
                loading: this.loading,
                status: this.status,
            }
        },

        status() {
            return this.job.status
        },

        urls() {
            return this.job.content_urls
        },
    },

    watch: {

    },

    created() {
        this.load()
    },

    mounted() {
        setTimeout(() => {
            this.initializing = false
            this.saveState()
        }, 1000)
    },

    methods: {
        hasSlot(name) {
            return typeof this.$scopedSlots[name] !== 'undefined'
        },

        load() {
            this.job = this.dataJob
            this.finishLoading()
            this.saveState
        },
    },
}
</script>
